import { env, BrandingOverride } from './env';

/**
 * Session-only developer bypass for the staging branding mask (SOPHIA-35093).
 * `?brandingBypass=1` turns the mask off for the current browser session only
 * (`?brandingBypass=0` re-enables it); nothing persists beyond the session and
 * the default is always masked, so prospects can never end up on the bypass.
 */
const BYPASS_STORAGE_KEY = 'sophia_branding_bypass';

export function brandingBypassActive(): boolean {
  try {
    const param = new URLSearchParams(window.location.search).get('brandingBypass');
    if (param === '1' || param === 'true') {
      sessionStorage.setItem(BYPASS_STORAGE_KEY, '1');
    } else if (param === '0' || param === 'false') {
      sessionStorage.removeItem(BYPASS_STORAGE_KEY);
    }
    return sessionStorage.getItem(BYPASS_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

/** The branding mask to apply, or null when unset for this env or bypassed. */
export function activeBrandingOverride(): BrandingOverride | null {
  if (!env.brandingOverride) return null;
  return brandingBypassActive() ? null : env.brandingOverride;
}
